// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"796":"ceae6997","4707":"e0959d8e","6254":"456a8810","8688":"5f09114e","9249":"78169ba9","9325":"7b224a80","9962":"4ab4375d"}[chunkId] + ".chunk.css";
};